import React from 'react'

import NewGamesPolling from './NewGamesPolling'
import TopSlotsPolling from './TopSlotsPolling'
import WagerSlotsPolling from './WagerSlotsPolling'

const ExternalGamesPolling: React.FC = () => (
  <>
    <NewGamesPolling />
    <TopSlotsPolling />
    <WagerSlotsPolling />
  </>
)

export default ExternalGamesPolling
